"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _LineChart = _interopRequireDefault(require("../components/v2charts/LineChart"));

var _RaddarChart = _interopRequireDefault(require("../components/v2charts/RaddarChart"));

var _BarChart = _interopRequireDefault(require("../components/v2charts/BarChart"));

var _TodoList = _interopRequireDefault(require("../components/TodoList"));

var _CardInfoV = _interopRequireDefault(require("@/views/dashboard/components/CardInfo/Admin/CardInfoV2"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: "admin-v2",
  components: {
    LineChart: _LineChart.default,
    RaddarChart: _RaddarChart.default,
    BarChart: _BarChart.default,
    TodoList: _TodoList.default,
    CardInfo: _CardInfoV.default
  },
  props: {
    cardData: Object,
    sevenDays: Object,
    channelLabels: Array,
    channelValues: Array,
    topRate: Array,
    bottomRate: Array,
    topOrgs: Array,
    topAgents: Array,
    loading: Boolean,
    lineGraphLabel: Array,
    sevenDaysNotEmpty: Boolean,
    successDate: String,
    failDate: String,
    channelDate: String,
    numberOfDecimal: Boolean
  },
  computed: {
    cardInfo: function cardInfo() {
      return [{
        icon: {
          style: 'font-size: 4em; color: Gold;',
          class: 'fas fa-clipboard-check',
          color: 'success'
        },
        text: this.$t('dashboard.queryApiTimes'),
        count: {
          endVal: parseInt(this.cardData.totalPayAmount[0].totalCountQueryApi),
          decimal: false
        }
      }, {
        icon: {
          style: 'font-size: 4em; color: DarkTurquoise;',
          class: 'fas fa-handshake',
          color: 'warning'
        },
        text: this.$t('dashboard.totalPayAmount'),
        count: {
          endVal: parseFloat(this.cardData.totalPayAmount[0].processTotalSumMoneyFrom),
          decimal: true
        }
      }, {
        icon: {
          style: 'font-size: 4em; color: DarkKhaki;',
          class: 'fas fa-clock',
          color: 'danger'
        },
        text: this.$t('dashboard.waitForSubmitting'),
        count: {
          endVal: parseInt(this.cardData.waitForSubmitting),
          decimal: false
        }
      }, {
        icon: {
          style: 'font-size: 4em; color: SeaGreen;',
          class: 'fas fa-money-bill-alt',
          color: 'info'
        },
        text: this.$t('dashboard.rechargeAmount'),
        count: {
          endVal: parseInt(this.cardData.rechargeAmount),
          decimal: true,
          numberOfDecimal: this.numberOfDecimal
        }
      }];
    }
  }
};
exports.default = _default;